import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

export interface MqttMessage {
  topic: string;
  message: string;
}

export interface MqttContextValue {
  mqttMessage: MqttMessage | null;
  subscribeRoom: (roomId: string | string[]) => void;
  unSubscribeRoom: (roomId: string | string[]) => void;
  isConnected: boolean;
  setIsConnected: Dispatch<SetStateAction<boolean>>;
  // Registered by a consumer inside QueryClientProvider so the provider (which
  // mounts above React Query) can trigger a refetch when the broker reports a
  // non-resumed session (connack.sessionPresent === false). Pass null to clear.
  setRefetchHandler: (handler: (() => void) | null) => void;
}

// INFO: added this create context in different file because defining
// it in same file as provider makes vite HMR unstable
// https://github.com/vitejs/vite/issues/3301#issuecomment-1080030773
export const MqttContext = createContext<MqttContextValue>({
  mqttMessage: null,
  subscribeRoom: () => {},
  unSubscribeRoom: () => {},
  isConnected: false,
  setIsConnected: () => {},
  setRefetchHandler: () => {},
});
